// src/admin/EventManager.js
import React, { useState, useEffect } from 'react';
import { fetchAllEvents, addEvent, updateEvent, deleteEvent } from '../FirebaseService';
import './EventManager.css'; // Import CSS

const EventManager = () => {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({ title: '', date: '', description: '', image: '' });
  const [editingEvent, setEditingEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEvents = async () => {
      const fetchedEvents = await fetchAllEvents();
      setEvents(fetchedEvents);
      setLoading(false);
    };
    loadEvents();
  }, []);

  const handleAddEvent = async () => {
    if (!newEvent.title || !newEvent.date || !newEvent.description) return;
    const result = await addEvent(newEvent);
    if (result.success) {
      setEvents([...events, { id: result.id, ...newEvent }]);
      setNewEvent({ title: '', date: '', description: '', image: '' });
    }
  };

  const handleUpdateEvent = async () => {
    if (!editingEvent) return;
    await updateEvent(editingEvent.id, editingEvent);
    setEvents(events.map(ev => ev.id === editingEvent.id ? editingEvent : ev));
    setEditingEvent(null);
  };

  const handleDeleteEvent = async (id) => {
    await deleteEvent(id);
    setEvents(events.filter(ev => ev.id !== id));
  };

  const startEditing = (event) => {
    setEditingEvent({ ...event });
  };

  if (loading) return <p>Đang tải sự kiện...</p>;

  return (
    <div className="event-manager p-4">
      <h2>Quản lý Sự kiện</h2>

      {/* Phần 1: Thêm sự kiện mới */}
      <div className="add-section mb-8">
        <h3>1. Thêm sự kiện mới</h3>
        <input
          type="text"
          placeholder="Tiêu đề"
          value={newEvent.title}
          onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
          className="mr-2 p-2 border"
        />
        <input
          type="text"
          placeholder="Ngày (dd/mm/yyyy)"
          value={newEvent.date}
          onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })}
          className="mr-2 p-2 border"
        />
        <textarea
          placeholder="Mô tả"
          value={newEvent.description}
          onChange={(e) => setNewEvent({ ...newEvent, description: e.target.value })}
          className="mr-2 p-2 border"
        />
        <input
          type="text"
          placeholder="URL hình ảnh"
          value={newEvent.image}
          onChange={(e) => setNewEvent({ ...newEvent, image: e.target.value })}
          className="mr-2 p-2 border"
        />
        <button 
          onClick={handleAddEvent}
          className="bg-blue-500 text-white p-2 rounded"
        >
          Thêm sự kiện
        </button>
      </div>

      {/* Phần 2: Các sự kiện cũ */}
      <div className="list-section">
        <h3>2. Các sự kiện cũ</h3>
        <ul>
          {events.map((event) => (
            <li key={event.id} className="mb-2">
              <span>{event.title} - {event.date}</span>
              <button onClick={() => startEditing(event)} className="ml-2 text-blue-500">Sửa</button>
              <button onClick={() => handleDeleteEvent(event.id)} className="ml-2 text-red-500">Xóa</button>
            </li>
          ))}
        </ul>

        {/* Form chỉnh sửa (hiển thị khi đang chỉnh sửa) */}
        {editingEvent && (
          <div className="edit-form mt-4">
            <h4>Chỉnh sửa sự kiện: {editingEvent.title}</h4>
            <input
              type="text"
              placeholder="Tiêu đề"
              value={editingEvent.title}
              onChange={(e) => setEditingEvent({ ...editingEvent, title: e.target.value })}
              className="mr-2 p-2 border"
            />
            <input
              type="text"
              placeholder="Ngày (dd/mm/yyyy)"
              value={editingEvent.date}
              onChange={(e) => setEditingEvent({ ...editingEvent, date: e.target.value })}
              className="mr-2 p-2 border"
            />
            <textarea
              placeholder="Mô tả"
              value={editingEvent.description}
              onChange={(e) => setEditingEvent({ ...editingEvent, description: e.target.value })}
              className="mr-2 p-2 border"
            />
            <input
              type="text"
              placeholder="URL hình ảnh"
              value={editingEvent.image}
              onChange={(e) => setEditingEvent({ ...editingEvent, image: e.target.value })}
              className="mr-2 p-2 border"
            />
            <button 
              onClick={handleUpdateEvent}
              className="bg-blue-500 text-white p-2 rounded mr-2"
            >
              Cập nhật
            </button>
            <button 
              onClick={() => setEditingEvent(null)}
              className="bg-gray-500 text-white p-2 rounded"
            >
              Hủy
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventManager;